import type { PlannerItem } from "@/types";
import mitt from "mitt";

export type EventUnsavedChangesParams = {
  onConfirm: () => void | Promise<void>;
};

export type EmitterEvents = {
  bodyClick: Event;
  selectContainerOpen: undefined;
  showUnsavedChanges: EventUnsavedChangesParams;
  logoutPrompt: undefined;
  updatePlannerTaskHistory: undefined;
  "plannerTask@update": PlannerItem;
  "plannerTask@delete": string;
};

const emitter = mitt<EmitterEvents>();

export default emitter;
